module.exports = window.ReactDOM;